

























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { UserAdviserDetailsMeta } from './model/UserAdviserDetailsMeta'
import PersonalDetailsMeta from './model/PersonalDetailsMeta'
import { ContractDetailsMeta } from './model/ContractDetailsMeta'
import { UserMeta } from '@core/model/common/UserMeta'
import { NationalityOptions } from '@master/model/options/NationalityAndCountryOptions'
import { inject } from 'inversify-props'
import { IAdviserService } from '@master/services/IAdviserService'

const userStore = namespace('UserStore')

@Component({
  components: {
    AppForm
  }
})
export default class ThePersonalDetails extends Vue {
  @userStore.State
  private user: UserMeta

  @userStore.State
  private userAdviserDetails!: UserAdviserDetailsMeta;

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get isOpsStaff () {
    return this.currentUser.systemrole === 'ops-staff'
  }

  get contractDetails () {
    return this.userAdviserDetails.contractDetails
  }

  get personalDetails () {
    return this.userAdviserDetails.personalDetails
  }

  @inject()
  private adviserService: IAdviserService

  // isLockedField (key: string): boolean {
  //   const listOfLockedFields = this.userAdviserDetails.myinfoLockedFieldsClient.map(e => camelCase(e))
  //   return listOfLockedFields.includes(key)
  // }

  get userAdviserDetailsStructure (): FormStructure<UserAdviserDetailsMeta> {
    return [
      {
        label: 'Date Contracted',
        key: 'dateContracted',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Date Terminated',
        key: 'dateTerminated',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Date Issued',
        key: 'dateIssued',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Contract Status',
        key: 'contractStatus',
        options: [
          { label: 'In-force', value: 'in-force' },
          { label: 'Pending', value: 'pending' },
          { label: 'Suspended', value: 'suspended' },
          { label: 'Terminated', value: 'terminated' },
          { label: 'Withdrawn', value: 'withdrawn' }
        ],
        disabled: !this.isOpsStaff
      },
      {
        label: 'Contract Type',
        key: 'contractType',
        options: this.adviserService.adviserContractTypeOptions(),
        disabled: !this.isOpsStaff
      },
      {
        label: 'Date of Last Promotion',
        key: 'dateOfLastPromotion',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'MAS Application Date',
        key: 'dateMasApplication',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'MAS Yearly Renewal',
        key: 'dateMasYearlyRenewal',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'MAS Tri-Yearly Renewal',
        key: 'dateMasTriYearlyRenewal',
        type: 'date',
        disabled: !this.isOpsStaff
      }
    ]
  }

  get contractDetailsStructure (): FormStructure<ContractDetailsMeta> {
    return [
      {
        label: 'IFPAS No.',
        key: 'ifpasNo',
        disabled: !this.isOpsStaff
      }
    ]
  }

  get userAdviserDetailsPersonalStructure (): FormStructure<UserAdviserDetailsMeta> {
    return [
      {
        label: 'Date of Birth',
        key: 'dateOfBirth',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'EP Issued Date',
        key: 'dateEpIssued',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'EP Expiry Date',
        key: 'dateEpExpiry',
        type: 'date',
        disabled: !this.isOpsStaff
      }
    ]
  }

  get personalDetailsStructure (): FormStructure<PersonalDetailsMeta> {
    return [
      {
        label: 'Place of Birth',
        key: 'placeOfBirth',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Marital Status',
        key: 'maritalStatus',
        options: [
          { label: 'Single', value: 'single' },
          { label: 'Married', value: 'married' },
          { label: 'Divorced', value: 'divorced' },
          { label: 'Widowed', value: 'widowed' }
        ],
        disabled: !this.isOpsStaff // || this.isLockedField('maritalStatus')
      },
      {
        label: 'Gender',
        key: 'gender',
        options: [
          { label: 'Male', value: 'male' },
          { label: 'Female', value: 'female' }
        ],
        disabled: !this.isOpsStaff
      },
      {
        label: 'Citizenship',
        key: 'nationality',
        options: [
          { label: '', value: '' },
          { label: 'Singaporean', value: 'singaporean' },
          { label: 'Singapore PR', value: 'pr' },
          { label: 'Singapore Pass Holder', value: 'passholders' },
          { label: 'Other Citizenship', value: 'others' }
        ],
        disabled: !this.isOpsStaff // || this.isLockedField('nationality')
      },
      {
        label: 'Please specify Nationality',
        key: 'nationalitySpecified',
        options: this.nationalityOptions,
        disabled: (!this.isOpsStaff ||
          this.personalDetails?.nationality ===
            'singaporean' ||
          this.personalDetails?.nationality ===
            'singaporeanpr') // || this.isLockedField('nationalitySpecified')
      },
      {
        label: 'Race',
        key: 'race',
        options: [
          { label: 'Chinese', value: 'chinese' },
          { label: 'Malay', value: 'malay' },
          { label: 'Indian', value: 'indian' },
          { label: 'Eurasian', value: 'eurasian' },
          { label: 'Others', value: 'others' }
        ],
        disabled: !this.isOpsStaff
      },
      {
        label: 'Immigration No.',
        key: 'immigrationNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Employment Pass No.',
        key: 'employmentPassNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Handphone No.',
        model: {
          get: () => this.user.mobile,
          set: (val) => { this.user.mobile = val }
        },
        disabled: !this.isOpsStaff // || this.isLockedField('mobile')
      },
      {
        label: 'Residential Tel No.',
        key: 'residentialNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Email',
        model: {
          get: () => this.user.email,
          set: (val) => { this.user.email = val }
        },
        disabled: !this.isOpsStaff // || this.isLockedField('email')
      },
      {
        label: 'Postal Code',
        key: 'postalCode',
        disabled: !this.isOpsStaff // || this.isLockedField('postalCode')
      },
      {
        label: 'Residential Address',
        key: 'residentialAddress',
        classes: ['colspan'],
        disabled: !this.isOpsStaff // || this.isLockedField('residentialAddress')
      }
    ]
  }

  get nationalityOptions () {
    return NationalityOptions
  }
}
